import { Box, Typography } from '@material-ui/core'
import { ConditionBadge } from 'components/facets/ConditionBadge'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import { useUser } from 'components/providers/UserProvider'
import { getCurrencySymbol } from 'lib/utils'
import { flagCode, getDisplayLocationName, InventoryArticle, Location } from 'shared'

interface ExistingArticleProps {
  article: InventoryArticle
  locations: Location[]
  showCard?: boolean
  showPrice?: boolean
  showComment?: boolean
  lineBreak?: boolean
  hideTitle?: boolean
}

export const ExistingArticle = (props: ExistingArticleProps): JSX.Element => {
  const { user } = useUser()
  const { locations, article, showComment } = props

  const quantity = locations.reduce((acc, loc) => acc + loc.quantity, 0)

  return (
    <Box padding={1}>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <div className="d-flex">
              <ConditionBadge condition={article.condition} />{' '}
              <LanguageFlag
                className="ms-1"
                height="16px"
                code={flagCode(article.idLanguage) || 'gg'}
              />
            </div>
            <div className="d-flex">
              {quantity}x {getCurrencySymbol(user.currency)}
              {article.price}
            </div>
            <div className="d-flex align-items-start">{showComment && article.comment}</div>
            <div className="d-flex flex-wrap">
              {locations.map((location) => {
                return (
                  <span key={location.name} style={{ marginRight: '10px' }}>
                    {getDisplayLocationName(location.name)} [{location.quantity}x];
                  </span>
                )
              })}
            </div>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
